<template>
    <div dusk="SmartZoomModalHeader" class="sticky top-0 z-30 bg-theme-bg text-theme-text">
        <div class="container mx-auto px-4">
            <div class="flex h-14 items-center justify-between">
                <div class="flex w-1/2 items-center">
                    <button
                        dusk="SmartZoomCloseButton"
                        :aria-label="localizations[lang].tooltips.back"
                        class="mr-3 rounded p-2 transition-colors hover:bg-theme-icon-bg focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        @click="toggleSmartZoom"
                    >
                        <svg-icon
                            icon="baseline-arrow_back-24px"
                            width="24px"
                            height="24px"
                            class="text-theme-icon"
                        ></svg-icon>
                    </button>
                    <div dusk="SmartZoomArticleCounter" class="px-2 text-sm">
                        {{ localizations[lang].article }} {{ currentArticleNumber }} /
                        {{ totalArticles }}
                    </div>
                </div>
                <div class="flex w-1/2 items-center justify-end">
                    <div
                        dusk="SmartZoomFontSizeControls"
                        class="inline-flex items-center"
                        style="border: none !important; outline: none !important"
                    >
                        <button
                            v-tooltip="localizations[lang].tooltips.zoomOut"
                            type="button"
                            class="group relative rounded-l px-3 py-2 transition-all hover:rounded-l hover:bg-theme-icon-bg focus:rounded-l focus:bg-theme-icon-bg focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 active:rounded-l active:bg-theme-icon-bg"
                            :aria-label="localizations[lang].tooltips.zoomOut"
                            @click="decreaseSmartZoomFontSizeMultiplier"
                        >
                            <svg-icon icon="minus" width="24px" height="24px" class="text-theme-icon"></svg-icon>
                            <span class="absolute bottom-1 right-0 top-1 w-px bg-theme-border"></span>
                        </button>
                        <button
                            v-tooltip="localizations[lang].tooltips.zoomIn"
                            type="button"
                            class="group rounded-r px-3 py-2 transition-all hover:rounded-r hover:bg-theme-icon-bg focus:rounded-r focus:bg-theme-icon-bg focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 active:rounded-r active:bg-theme-icon-bg"
                            :aria-label="localizations[lang].tooltips.zoomIn"
                            @click="increaseSmartZoomFontSizeMultiplier"
                        >
                            <svg-icon icon="plus" width="24px" height="24px" class="text-theme-icon"></svg-icon>
                        </button>
                    </div>
                    <button
                        v-if="isShareEnabled"
                        v-tooltip="localizations[lang].tooltips.share"
                        :aria-label="localizations[lang].tooltips.share"
                        dusk="SmartZoomShareButton"
                        class="ml-4 rounded p-2 transition-colors hover:bg-theme-icon-bg focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        @click="share"
                    >
                        <svg-icon
                            icon="baseline-share-24px"
                            width="24px"
                            height="24px"
                            class="text-theme-icon"
                        ></svg-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
'use strict';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { uiAPI } from '../../../src/js/communication';

export default {
    props: {
        currentArticle: {
            type: Object,
            default: null,
        },
        currentArticleNumber: {
            type: Number,
            required: true,
        },
        totalArticles: {
            type: Number,
            required: true,
        },
    },
    computed: {
        ...mapState(['issue', 'localizations', 'lang']),
        ...mapGetters(['canUseNativeShare', 'isShareEnabled']),
    },
    methods: {
        ...mapMutations([
            'toggleSmartZoom',
            'decreaseSmartZoomFontSizeMultiplier',
            'increaseSmartZoomFontSizeMultiplier',
            'openSocialShare',
        ]),
        share() {
            // Early return if no article
            if (!this.currentArticle) {
                return;
            }

            const text = (() => {
                if (!this.currentArticle.body) {
                    return this.localizations[this.lang].imReading;
                }

                const tmpEl = document.createElement('DIV');
                tmpEl.innerHTML = this.currentArticle.body;
                let text = tmpEl.textContent || tmpEl.innerText || '';
                text = text.substring(0, 90);
                return `${this.localizations[this.lang].imReading} "${text}..."`;
            })();

            if (this.canUseNativeShare) {
                uiAPI.shareContent({
                    title: this.currentArticle.title || '',
                    text,
                    url: `${this.issue.issue_url}?article_id=${this.currentArticle.id}`,
                });
            } else {
                this.openSocialShare({
                    shareArticle: true,
                    currentArticleId: this.currentArticle.id,
                });
            }
        },
    },
};
</script>
